<template>
  <div>
    <h1>Configure Cube Widget</h1>
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      size="small"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="Title"
            prop="title"
          >
            <el-input
              v-model="form.title"
              placeholder="Title"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Date Range"
            prop="dateRange"
          >
            <el-select
              v-model="form.dateRange"
              placeholder="Please select a date range"
              class="w-100"
            >
              <el-option
                label="Week to Date"
                value="week"
              />
              <el-option
                label="Month to Date"
                value="month"
              />
              <el-option
                label="Year to Date"
                value="year"
              />
              <el-option
                label="Fixed Date Range"
                value="fixed"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.dateRange === 'fixed'">
        <el-col>
          <el-form-item
            label="Fixed Date Range"
            prop="fixedDateRange"
          >
            <el-date-picker
              v-model="form.fixedDateRange"
              type="daterange"
              format="dd/MM/yyyy"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              class="w-100"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Time Break Down"
            prop="timeBreakDown"
          >
            <el-select
              v-model="form.timeBreakDown"
              placeholder="Please select a time break down"
              class="w-100"
            >
              <el-option
                label="By Day"
                value="Day"
              />
              <el-option
                label="By Week"
                value="Week"
              />
              <el-option
                label="By Month"
                value="Month"
              />
              <el-option
                label="By Year"
                value="Year"
              />
              <el-option
                label="By Date"
                value="Date"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Filter"
            prop="filter"
          >
            <el-select
              v-model="form.filter"
              placeholder="Please select a filter"
              class="w-100"
            >
              <el-option
                v-for="filter in filters"
                :key="filter"
                :label="filter"
                :value="filter"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Chart Type"
            prop="chartType"
          >
            <el-select
              v-model="form.chartType"
              placeholder="Please select a chart type"
              class="w-100"
            >
              <el-option
                v-for="type in availableTypes"
                :key="type.value"
                :label="type.label"
                :value="type.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!$route.params.accountId">
        <el-col>
          <el-form-item
            label="Accounts"
            prop="accounts"
          >
            <el-select
              v-model="form.accounts"
              multiple
              filterable
              remote
              value-key="id"
              placeholder="Please enter a account name"
              class="w-100"
              :remote-method="remoteMethodAccount"
              :loading="isLoadingAccounts"
            >
              <el-option
                v-for="item in accounts"
                :key="item.id"
                :label="item.name"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Carriers"
            prop="carriers"
          >
            <el-select
              v-model="form.carriers"
              multiple
              filterable
              remote
              value-key="id"
              placeholder="Please enter a carrier name"
              class="w-100"
              :remote-method="remoteMethodCarrier"
              :loading="isLoadingCarriers"
            >
              <el-option
                v-for="item in carriers"
                :key="item.id"
                :label="item.name"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Include Children Accounts"
            prop="showChildrenAccts"
          >
            <el-switch v-model="form.showChildrenAccts" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        title: 'Cube (m3)'
      },
      accounts: [],
      isLoadingAccounts: false,
      carriers: [],
      isLoadingCarriers: false,
      showChildrenAccts: false,
      availableTypes: [
        { label: 'Line', value: 'Line' },
        { label: 'Area', value: 'Area' },
        { label: 'Bar', value: 'Bar' },
        { label: 'Pie', value: 'Pie' }
      ],
      filters: ['By State', 'By Lane', 'By Carrier', 'By Service', 'By Branch'],
      report: 'FreightSummaryBranch',
      yKey: 'Cube (m3)',
      isResizable: true,
      rules: {
        title: [
          { required: true, message: 'Title of widget is required', trigger: 'blur' }
        ],
        dateRange: [
          { required: true, message: 'Date Range of widget is required', trigger: 'change' }
        ],
        fixedDateRange: [
          { required: true, message: 'Fixed Date Range of widget is required', trigger: 'change' }
        ],
        chartType: [
          { required: true, message: 'Type of widget is required', trigger: 'change' }
        ],
        filter: [
          { required: true, message: 'Filter of widget is required', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    submit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let widget = this.getFormattedWidget()
          this.$emit('submitted', widget)
        }
      })
    },
    getFormattedWidget () {
      return {
        name: 'Cube',
        configuration: {
          title: this.form.title,
          chartType: this.form.chartType,
          isResizable: this.isResizable,
          timeBreakDown: this.form.timeBreakDown || '',
          report: this.report,
          xKey: this.getXKeyByFilter(this.form.filter),
          yKey: this.yKey,
          params: {
            dateFrom: this.form.dateRange === 'fixed' ? this.$moment(this.form.fixedDateRange[0]).format('YYYY-MM-DD') : this.form.dateRange,
            dateTo: this.form.dateRange === 'fixed' ? this.$moment(this.form.fixedDateRange[1]).format('YYYY-MM-DD') : 'today',
            accountId: this.form.accounts.map(a => a.id).slice(','),
            carrierId: this.form.carriers.map(c => c.id).slice(','),
            internalConsOnly: true,
            showChildrenAccts: this.form.showChildrenAccts,
            carrierBreakDown: this.form.filter === 'By Carrier',
            zone: this.form.filter === 'By Lane',
            carrierService: this.form.filter === 'By Service',
            state: this.form.filter === 'By State',
            branchBreakDown: this.form.filter === 'By Branch',
            dayBreakDown: this.form.timeBreakDown === 'Day',
            weekBreakDown: this.form.timeBreakDown === 'Week',
            monthBreakDown: this.form.timeBreakDown === 'Month',
            yearBreakDown: this.form.timeBreakDown === 'Year'
          }
        }
      }
    },
    getXKeyByFilter (filter) {
      switch (filter) {
        case 'By State': {
          return 'State'
        }
        case 'By Lane': {
          return 'Zone To'
        }
        case 'By Carrier': {
          return 'Carrier Name'
        }
        case 'By Service': {
          return 'Service Name'
        }
        case 'By Branch': {
          return 'Branch Name'
        }
      }
    },
    remoteMethodAccount (query) {
      this.isLoadingAccounts = true
      this.$sdk.account.list(builder => {
        builder.filters = { account_name: query, account_active: 1 }
      }).then(res => {
        this.accounts = res
      }).finally(() => { this.isLoadingAccounts = false })
    },
    remoteMethodCarrier (query) {
      this.isLoadingCarriers = true
      this.$sdk.carrier.list(builder => {
        builder.filters = { 'carrier_name': query }
      }).then(res => {
        this.carriers = res
      }).finally(() => { this.isLoadingCarriers = false })
    }
  }
}
</script>
